import { apiPut } from "../ApiMethod";
import { setCampusData } from "../../mappers";

export const updateCampus = async (data, id) => {
  const response = await apiPut("_campuses", id, data);
  return { ...response, data: setCampusData(response.data) };
};
